import { AdditionalDocumentTags, DocumentTags } from './enums'

export const additionalDocumentTypeOptions: Record<
  AdditionalDocumentTags,
  { label: string; key?: string }
> = {
  [DocumentTags.STATEMENT_OF_PURPOSE]: { label: 'Statement of Purpose', key: 'statementOfPurpose' },
  [DocumentTags.LETTER_OF_RECOMMENDATION]: {
    label: 'Letter of Recommendation',
    key: 'letterOfRecommendation',
  },
  [DocumentTags.CONSENT_FORM]: { label: 'Consent Form', key: 'consentForm' },
  [DocumentTags.GMAT_SCORE]: { label: 'GMAT Score', key: 'gmatScore' },
  [DocumentTags.GRE_SCORE]: { label: 'GRE Score', key: 'greScore' },
  [DocumentTags.RESUME]: { label: 'Resume', key: 'resume' },
  [DocumentTags.EMPLOYMENT_LETTER]: { label: 'Employment Letter', key: 'employmentLetter' },
  [DocumentTags.VOLUNTEER_LETTER]: { label: 'Volunteer Letter', key: 'volunteerLetter' },
  [DocumentTags.BIRTH_CERTIFICATE]: { label: 'Birth Certificate', key: 'birthCertificate' },
  [DocumentTags.WES_EVALUATION_REPORT]: {
    label: 'WES Evaluation Report',
    key: 'wesEvaluationReport',
  },
  [DocumentTags.PORTFOLIO]: { label: 'Portfolio', key: 'portfolio' },
  [DocumentTags.FINANCIAL_PROOF]: { label: 'Financial Proof', key: 'financialProof' },
  [DocumentTags.ADDITIONAL_DOCUMENT]: { label: 'Other' },
}

export const documentTypeOptions: Record<DocumentTags, { label: string }> = {
  ...additionalDocumentTypeOptions,
  [DocumentTags.CERTIFICATE]: { label: 'Certificate' },
  [DocumentTags.DECLINED_LETTER]: { label: 'Declined Letter' },
  [DocumentTags.DESTINATION_COUNTRY_STATUS]: { label: 'Destination Country Status' },
  [DocumentTags.LANGUAGE_TEST]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_IELTS]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_PTE]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_TOEFL]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_DUOLINGO]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_OTHER]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_CAEL]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_MET]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_CAMBRIDGE]: { label: 'Language Test' },
  [DocumentTags.LANGUAGE_TEST_EPP]: { label: 'Language Test' },
  [DocumentTags.PASSPORT]: { label: 'Passport' },
  [DocumentTags.PRE_OFFER_LETTER]: { label: 'Pre Offer Letter' },
  [DocumentTags.STUDY_PERMIT]: { label: 'Study Permit' },
  [DocumentTags.TRANSCRIPTS]: { label: 'Transcript' },
  [DocumentTags.VISITOR_TOURIST_VISA]: { label: 'Visitor Tourist Visa' },
  [DocumentTags.WORK_PERMIT]: { label: 'Work Permit' },
  [DocumentTags.WAITLIST_LETTER]: { label: 'Waitlist Letter' },
  [DocumentTags.FINAL_OFFER_LETTER]: { label: 'Final Offer Letter' },
  [DocumentTags.VISA_OUTCOME]: { label: 'Visa Outcome' },
  [DocumentTags.TUITION_DEPOSIT_RECEIPT]: { label: 'Tuition Deposit Receipt' },
}

export function getDocumentTypeLabel(documentType: string): string {
  if (documentTypeOptions[documentType as DocumentTags]) {
    return documentTypeOptions[documentType as DocumentTags].label
  }
  return documentType
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
